class ConfigManager {
	static instance;

	constructor() {
		if (ConfigManager.instance) {
			return ConfigManager.instance;
		}
		this.config = {};
		ConfigManager.instance = this;
	}

	// Metodo per impostare la configurazione
	setConfig(config) {
		this.config = { ...this.config, ...config };
	}

	// Metodo per ottenere la configurazione
	getConfig(key) {
		return this.config[key];
	}
}

export const configManager = new ConfigManager();
